import { render, staticRenderFns } from "./UploadCerti.vue?vue&type=template&id=e908449e&scoped=true&"
import script from "./UploadCerti.vue?vue&type=script&lang=js&"
export * from "./UploadCerti.vue?vue&type=script&lang=js&"
import style0 from "./UploadCerti.vue?vue&type=style&index=0&id=e908449e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e908449e",
  null
  
)

export default component.exports